import {DEFAULT_VERTICAL_WIDTH, LAYOUTS_HORIZONTAL, LAYOUTS_LIST, LAYOUTS_VERTICAL} from './constants';

export const layoutValues: Record<number, {width: number}> = {
  [LAYOUTS_VERTICAL]: {
    width: DEFAULT_VERTICAL_WIDTH,
  },
  [LAYOUTS_HORIZONTAL]: {
    width: 680,
  },
  [LAYOUTS_LIST]: {
    width: 680,
  },
};
